<template>
    <div v-if="summary" class="summary_box_specific relative h-0" :class="[summary ? summary.slug : '']">
        <img class="absolute top-0 left-0 block w-full h-full object-contain md:object-cover" :src="'fr/images/summary/' + summary.image" alt="" />
    </div>
</template>

<script>
    export default {
        name: 'SummaryBoxSpecific',
        props: {
            summary: null
        }
    };
</script>

<style scoped lang="scss">
    .summary_box_specific {
        width: calc($box_size_mobile - $box_spacing);
        padding-bottom: calc($box_size_mobile - $box_spacing);
        margin-top: $box_spacing;
        margin-left: 170px;
        @media (min-width: 768px) {
            // width: calc(100% - ($box_size - ($box_spacing)) * 3 - ($box_spacing * 18));
            width: 22%;
            padding-bottom: calc($box_size - $box_spacing);
            margin-left: $box_spacing;
            bottom: -20px;
        }
    }
</style>
